// Site & Signal - Homepage Content
// Modular, skimmable, personally relevant

export const siteContent = {
  brand: {
    name: "Site & Signal"
  },
  
  // HERO SECTION - Punchy, minimal
  hero: {
    headline: "Missed messages cost trades work every week.",
    subheadline: "The phone rings. Messages come in. If you miss them, the job goes to someone else.",
    cta: "Book a quick chat",
    microCopy: "No sales pitch. Just a conversation.",
    clarification: "This isn't about more leads — it's about not losing the ones you already get.",
    image: "https://customer-assets.emergentagent.com/job_5fefe93c-7fd7-4c40-bb3d-0e7903db545b/artifacts/ot0l24ci_3b4c63a4-8498-40f6-b2c2-48b7d89e24f6.png"
  },
  
  // CATEGORY SELECTOR
  categorySelector: {
    question: "What do you do?",
    categories: [
      {
        id: "trades",
        label: "Trades & construction",
        headline: "When you're on the tools, enquiries don't wait.",
        bullets: [
          "Phone rings while you're working",
          "Messages come in while you're busy",
          "The job moves on if you're slow to reply"
        ]
      },
      {
        id: "home-garden",
        label: "Home & garden",
        headline: "When you're on site, customers can't wait.",
        bullets: [
          "Enquiries come in while you're with a client",
          "You reply hours later — they've moved on",
          "Good work lost to slow response"
        ]
      },
      {
        id: "local-services",
        label: "Local services",
        headline: "When you're with a client, the next one won't wait.",
        bullets: [
          "Phone rings mid-appointment",
          "Messages pile up through the day",
          "Someone else picks up first"
        ]
      }
    ]
  },
  
  // IS THIS FOR YOU - Recognition tiles
  isThisForYou: {
    title: "Is this for you?",
    tiles: [
      {
        category: "Trades",
        reality: "Phone rings while you're working. You can't answer. The job moves on.",
        examples: "Plumbers, electricians, builders, roofers"
      },
      {
        category: "Home & garden",
        reality: "Hands full on site. Enquiries come in. You reply too late.",
        examples: "Gardeners, landscapers, cleaners"
      },
      {
        category: "Local services",
        reality: "With a client. Someone else picks up first.",
        examples: "Tutors, therapists, mobile services"
      }
    ]
  },
  
  // WHAT THIS TAKES OFF YOUR PLATE
  whatWeHandle: {
    title: "What this takes off your plate",
    stressRelief: "We handle the messages. You focus on the job.",
    items: [
      { text: "People can find you" },
      {
        text: "Calls and messages reach you before the job moves on",
        clarification: "Calls still come straight to you. Messages are captured if you can't answer."
      },
      { text: "Enquiries reach you, not lost in spam" },
      { text: "Your website and Google profile, sorted" }
    ]
  },
  
  // HOW IT WORKS - Strong anchor
  howItWorks: {
    title: "How it works",
    steps: [
      {
        number: "1",
        title: "Quick chat",
        description: "15 mins. No forms."
      },
      {
        number: "2",
        title: "We build it",
        description: "Live within a week."
      },
      {
        number: "3",
        title: "Jobs come in",
        description: "You do the work."
      }
    ]
  },
  
  // HUMAN TRUST BLOCK
  humanTrust: {
    name: "Kwesi",
    intro: "Hi, I'm Kwesi.",
    bio: "I'm based in Kent and work with a small number of local businesses each month.",
    constraint: "I set this up so customers can reach you — even when you're busy.",
    headshot: "https://customer-assets.emergentagent.com/job_local-tradespro/artifacts/r0qg5ues_1694612058502.jpg",
    exampleSite: {
      text: "Example: Mingle Gardens – Kent",
      url: "https://minglegardens.emergent.host/"
    }
  },
  
  // PRICING
  pricing: {
    title: "Founding Partner slots",
    subtitle: "Limited to 5 businesses",
    valueReason: "£45/month means jobs don't slip through while you're working.",
    setup: {
      amount: "£0",
      label: "Setup"
    },
    monthly: {
      amount: "£45",
      label: "/month"
    },
    paymentNote: "Payment only after we've spoken.",
    ownership: {
      title: "You own everything.",
      points: [
        "Your domain, website, Google profile",
        "Cancel anytime"
      ]
    },
    whatYouGet: [
      "Website set up and live",
      "Google Business Profile sorted",
      "Enquiries captured and routed to you"
    ],
    toQualify: {
      title: "To qualify",
      intro: "Happy to:",
      requirements: [
        "15-min feedback call after 30 days",
        "Short review once you're happy"
      ]
    },
    cta: "Apply for a slot"
  },
  
  // NOT FOR YOU - Filter
  notForYou: {
    title: "Probably not right if...",
    items: [
      "You already have a marketing agency",
      "You need to sell products online",
      "You're part of a franchise"
    ]
  },
  
  // FINAL CTA
  contact: {
    title: "Stop losing jobs to missed messages",
    cta: "Book a quick chat",
    microcopy: "We'll email within 24 hours to arrange a call."
  },
  
  // FOOTER
  footer: {
    copyright: "Site & Signal",
    location: "Based in the UK"
  }
};
